export default function generateStaticReference(style, selector) {
  if (typeof style === 'string') {
    return style;
  }

  if (selector) {
    return selector + JSON.stringify(style);
  }

  return '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/node_modules/fela/es/generateStaticReference.js
// module id = 736
// module chunks = 0